import { render } from "./ErrorCheck.vue?vue&type=template&id=e95b5fb4"
import script from "./ErrorCheck.vue?vue&type=script&lang=js"
export * from "./ErrorCheck.vue?vue&type=script&lang=js"

import exportComponent from "/Users/mae/Dev/mamp/htdocs/mfj_renewal/manage/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__